<template>
  <section id="section__settlement" class="view-container">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12">
          <span class="font--m-3">대호국밥영주점</span>
        </v-col>
      </v-row>
      <Calendar></Calendar>
      <TodayDeposite></TodayDeposite>
      <SalesHistoryList></SalesHistoryList>
      <DepositeDueList></DepositeDueList>
      <BasicButton @click="alert">추가로 매출 당겨 받기!</BasicButton>
    </div>
  </section>
</template>

<script>
import Calendar from '@/components/settlement/Calendar.vue'
import TodayDeposite from '@/components/settlement/TodayDeposite.vue'
import SalesHistoryList from '@/components/settlement/SalesHistoryList.vue'
import DepositeDueList from '@/components/settlement/DepositeDueList.vue'

export default {
  components: {
    Calendar,
    TodayDeposite,
    SalesHistoryList,
    DepositeDueList,
  },
  methods: {
    alert() {
      this.$swal.basic.alert({
        html: `다음 달에 미리 발생할 매출도 <br /> 미리 당겨드리는 '펀다나우' <br/><br/> 서비스 오픈을 준비하고 있어요!`,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
#section__settlement {
}
</style>
